import React, { useState, useEffect, useCallback } from 'react'
import './saasPpt.scss'
import { b2ValueUnit } from 'common/utils'
import {
  Radio,
  Typography,
  Button,
  Notification,
  Space,
  Upload,
  Message,
  Trigger,
  Divider,
  Input,
  Tooltip
} from '@arco-design/web-react'

import Emptydata_img from 'asserts/Emptydata_img.svg'
import { BosClient } from '@baiducloud/sdk'
import Clear_img from 'asserts/clear.svg'
import cirle_img from 'asserts/cirle.svg'

import {
  newGetappList,
  jsonToEditorUrl,
  textToEditorUrl,
  putapp,
  upDataInfo,
  upload
} from 'api/apis'

const SaasPPT = () => {
  const [type, setType] = useState('MD格式生成')
  const [apiToken, setApiToken] = useState('')
  const [pptUrl, setPptUrl] = useState()
  const [text, setText] = useState()
  const [record, setRecord] = useState(
    JSON.parse(localStorage.getItem('record'))
  )
  const [visible, setVisible] = useState(false)
  const [fileList, setFileList] = useState([])
  const [attachment, setAttachment] = useState()
  const [name, setName] = useState(record.name)
  const [desc, setDesc] = useState(record.desc)
  const [appId, setAppId] = useState(record.project_app?.app_id || '')
  const [domain, setDomain] = useState(record.domain)
  const [notice_url, setNotice_url] = useState(record.notice_url)
  const options = [
    {
      value: 'MD格式生成',
      label: 'MD格式生成'
    },
    {
      value: 'Json格式生成',
      label: 'Json格式生成',
      disabled: true
    }
  ]
  const exampleTextList = [
    `# 千年华韵：中国传统文化艺术巡礼
## 一、开篇：传统文化的魅力溯源
### 文化的定义与价值
#### 传统文化的内涵界定
- 中国传统文化是中华民族在长期历史发展中形成的，包括思想观念、价值体系、道德规范、文学艺术、风俗习惯等多个方面，是民族身份的重要标识。
#### 传统文化对民族精神的影响
- 它塑造了中华民族坚韧不拔、自强不息、团结友爱、崇尚和谐等精神品质，是民族凝聚力和向心力的重要源泉。
### 艺术在文化中的地位
#### 艺术作为文化的载体
- 艺术通过绘画、书法、音乐、舞蹈、戏曲等多种形式，生动地展现了不同历史时期的社会风貌、人们的生活状态和情感世界。
#### 艺术对文化传承的推动
- 艺术作品作为文化传承的重要载体，能够将先辈们的智慧和经验代代相传，激发后人对传统文化的热爱和探索欲望。

## 二、绘画艺术：笔墨丹青绘千年
### 古代绘画的流派与风格
#### 宫廷绘画的华贵典雅
- 宫廷绘画以服务皇室为目的，注重画面的精细、华丽和庄重，多描绘宫廷生活、历史故事和宗教题材，如唐代阎立本的《步辇图》。
#### 文人画的意境追求
- 文人画强调画家的个人情感表达和意境营造，追求“诗中有画，画中有诗”的境界，注重笔墨情趣和气韵生动，如宋代苏轼、米芾等人的作品。
#### 民间绘画的质朴生动
- 民间绘画源于民间生活，具有浓郁的生活气息和地方特色，题材广泛，包括年画、剪纸、刺绣图案等，反映了劳动人民的审美情趣和生活愿望。
### 绘画技法的传承与创新
#### 传统技法的精髓
- 中国传统绘画技法丰富多样，如工笔画的细腻勾勒、写意画的豪放洒脱、没骨画的淡雅清新等，这些技法是历代画家智慧的结晶。
#### 现代绘画对传统的借鉴与发展
- 现代画家在继承传统技法的基础上，不断探索创新，融入西方绘画的元素和表现手法，形成了具有时代特色的绘画风格。

## 三、书法艺术：翰墨飘香传千古
### 书法的历史演变
#### 从甲骨文到篆隶楷行草
- 甲骨文是中国最早的文字形式，具有古朴、神秘的风格；篆书分为大篆和小篆，线条规整、圆润；隶书的出现使汉字书写更加便捷，具有波磔之美；楷书结构严谨、端庄秀丽；行书和草书则更加自由奔放，富有艺术感染力。
#### 各个朝代书法的特点与代表作品
- 秦代以小篆为代表，如李斯的《峄山碑》；汉代隶书盛行，如《张迁碑》《曹全碑》；唐代楷书达到鼎盛，有颜真卿、柳公权等大家的作品；宋代行书发展迅速，苏轼、黄庭坚、米芾、蔡襄并称“宋四家”。
### 书法的艺术价值与文化内涵
#### 书法与哲学的交融
- 书法中的线条、结构和布局蕴含着道家的阴阳平衡、儒家的中庸之道等哲学思想，体现了中国人对宇宙、自然和人生的深刻理解。
#### 书法对个人修养的提升
- 练习书法需要耐心、细心和恒心，能够培养人的专注力、观察力和创造力，提升个人的审美水平和文化素养。

## 四、音乐舞蹈：弦歌曼舞展风情
### 传统音乐的分类与特色
#### 宫廷音乐的庄重肃穆
- 宫廷音乐主要用于宫廷仪式、庆典和祭祀活动，具有严格的礼仪规范和音乐程式，如雅乐。
#### 民间音乐的丰富多彩
- 民间音乐包括民歌、器乐、说唱音乐等，题材广泛，形式多样，反映了不同地区、不同民族的生活风貌和情感世界，如陕北民歌、江南丝竹等。
#### 宗教音乐的神秘空灵
- 宗教音乐与佛教、道教等宗教信仰密切相关，具有独特的音乐风格和表现手法，能够营造出神秘、空灵的氛围，如佛教的梵呗、道教的道曲。
### 传统舞蹈的起源与发展
#### 原始舞蹈的祭祀功能
- 原始舞蹈起源于人类对自然和神灵的崇拜，主要用于祭祀活动，以表达对神灵的敬畏和祈求。
#### 古代宫廷舞蹈的华丽典雅
- 宫廷舞蹈在古代主要用于宫廷娱乐和庆典活动，具有严格的舞蹈规范和技巧要求，舞姿优美、华丽典雅，如唐代的霓裳羽衣舞。
#### 民族民间舞蹈的地域特色
- 民族民间舞蹈是各民族在长期生产生活中形成的，具有鲜明的地域特色和民族风格，如蒙古族的安代舞、维吾尔族的手鼓舞等。

## 五、戏曲艺术：粉墨登场诉悲欢
### 戏曲的起源与形成
#### 原始歌舞与巫觋表演
- 原始歌舞是戏曲的源头之一，人们在劳动和生活中通过歌舞来表达情感和愿望；巫觋表演则具有宗教和神秘色彩，为戏曲的形成提供了一定的基础。
#### 唐代参军戏与宋代杂剧
- 唐代参军戏是一种以滑稽调笑为主的表演形式，对后世戏曲的发展产生了重要影响；宋代杂剧则更加成熟，有了固定的角色行当和表演程式。
### 戏曲的种类与特点
#### 京剧的博大精深
- 京剧是中国的国粹，集唱、念、做、打于一体，具有独特的艺术风格和表演技巧，角色行当分为生、旦、净、丑四大类，代表剧目有《霸王别姬》《贵妃醉酒》等。
#### 地方戏曲的百花齐放
- 中国各地有许多具有特色的地方戏曲，如河南的豫剧、四川的川剧、广东的粤剧等，它们在唱腔、表演、服饰等方面各具特色，反映了当地的文化和风俗习惯。
### 戏曲的文化意义与社会功能
#### 传承历史文化的载体
- 戏曲通过演绎历史故事和传说，传承了中华民族的历史文化，让观众了解过去的社会风貌和人们的生活方式。
#### 娱乐与教育的双重作用
- 戏曲作为一种大众娱乐形式，能够丰富人们的精神生活；同时，它也蕴含着道德教育和价值观引导的功能，通过正反面人物的塑造，传递正能量。

## 六、传统手工艺：匠心独运铸瑰宝
### 陶瓷工艺的辉煌成就
#### 原始陶器的质朴之美
- 原始陶器是人类最早的手工艺品之一，具有实用和艺术的双重价值，如仰韶文化的彩陶，图案丰富多样，反映了当时人们的生活和审美情趣。
#### 历代瓷器的发展与创新
- 从商代的原始青瓷到东汉的成熟青瓷，再到唐代的南青北白、宋代的五大名窑、元代的青花瓷、明清的五彩瓷和粉彩瓷等，中国瓷器不断发展和创新，成为世界闻名的艺术瑰宝。
### 纺织刺绣的精美绝伦
#### 丝绸文化的起源与传播
- 中国是丝绸的发源地，丝绸文化历史悠久，通过丝绸之路传播到世界各地，对世界文明的发展产生了重要影响。
#### 刺绣艺术的流派与技法
- 中国刺绣艺术流派众多，如苏绣、湘绣、蜀绣、粤绣等，各有其独特的技法和风格，刺绣作品针法细腻、色彩鲜艳、形象逼真。
### 木雕石雕的鬼斧神工
#### 传统木雕的题材与工艺
- 传统木雕题材广泛，包括神话传说、历史故事、花鸟鱼虫等，工艺精湛，有圆雕、浮雕、透雕等多种技法，作品栩栩如生。
#### 石雕艺术的历史与特色
- 石雕艺术在中国也有着悠久的历史，如秦代的兵马俑、汉代的霍去病墓石雕等，具有雄浑、大气的风格；民间石雕则更加注重生活气息和装饰性。

## 七、结语：传统文化的传承与展望
### 传统文化面临的挑战与机遇
#### 现代化进程中的冲击
- 随着现代化进程的加速，西方文化和价值观的传入对传统文化产生了一定的冲击，一些传统技艺和文化习俗面临失传的危险。
#### 文化复兴的时代机遇
- 当今社会，人们对传统文化的重视程度不断提高，国家也出台了一系列政策支持传统文化的传承和发展，为传统文化的复兴提供了良好的机遇。
### 传承与发展的策略与建议
#### 教育传承的重要性
- 加强传统文化教育，将传统文化纳入学校教育体系，培养青少年对传统文化的兴趣和热爱，是传承传统文化的重要途径。
#### 创新发展的路径探索
- 在传承传统的基础上，结合现代科技和审美需求，对传统文化进行创新发展，如开发文化创意产品、举办文化活动等，让传统文化焕发出新的活力。`,
    `# 王者荣耀VS英雄联盟
## 1. 游戏基本信息对比
### 1.1 游戏概述
#### 1.1.1 游戏类型与玩法
- 《王者荣耀》是快节奏的MOBA手游，游戏时长15-20分钟，适合碎片化时间游玩。
- 《英雄联盟》是经典的PC端MOBA游戏，比赛时长30-60分钟，注重团队协作和策略。
#### 1.1.2 开发与运营
- 《王者荣耀》由腾讯天美工作室开发，2015年上线，专为移动平台设计，操作简便。
- 《英雄联盟》由美国Riot Games开发，2009年发布，是经典的PC端MOBA游戏，操作复杂度高。
#### 1.1.3 游戏背景设定
- 《王者荣耀》背景设定在架空的王者大陆，融合了中国传统文化元素，英雄角色风格多样。
- 《英雄联盟》背景设定在符文之地，拥有庞大的世界观和丰富的英雄背景故事，每个英雄都有独特背景。
### 1.2 市场表现与影响力
#### 1.2.1 用户规模与下载量
- 《王者荣耀》作为国民级手游，拥有庞大的用户群体，全球下载量超过10亿次，日活跃用户数达数千万。
- 《英雄联盟》在PC端MOBA领域占据重要地位，全球月活跃用户数超1亿，赛事观众数量庞大。
#### 1.2.2 收入与商业价值
- 《王者荣耀》凭借内购模式，年收入超200亿元，成为腾讯重要的收入来源之一，带动周边产业发展。
- 《英雄联盟》通过游戏内购、赛事版权等盈利，年收入超10亿美元，其赛事奖金池高达数千万美元。
#### 1.2.3 电竞赛事影响力
- 《王者荣耀》举办KPL等赛事，赛事奖金高，吸引了众多职业选手和俱乐部参与，赛事直播观看量达数亿。
- 《英雄联盟》的S系列赛是全球最具影响力的电竞赛事之一，每年吸引全球数亿观众，赛事奖金池超千万美元。
## 2. 游戏系统与玩法对比
### 2.1 英雄与角色
#### 2.1.1 英雄数量与种类
- 《王者荣耀》英雄数量超100个，涵盖战士、法师、刺客、射手、坦克、辅助等多种类型，满足不同玩家喜好。
- 《英雄联盟》英雄数量超160个，角色设计风格多样，技能独特，玩家可选择的英雄种类丰富。
#### 2.1.2 英雄技能与操作难度
- 《王者荣耀》英雄技能简单易懂，操作难度较低，新手玩家可快速上手，适合移动平台操作。
- 《英雄联盟》英雄技能复杂多样，操作难度高，需要玩家花费大量时间练习，竞技性更强。
#### 2.1.3 英雄获取方式
- 《王者荣耀》英雄可通过内购、活动等方式获取，部分英雄还可通过游戏内货币兑换，获取方式多样。
- 《英雄联盟》英雄可通过游戏内货币购买，也可通过内购获取，游戏内货币可通过游戏获得。
### 2.2 游戏模式与玩法
#### 2.2.1 主要游戏模式
- 《王者荣耀》主要模式为5V5对战，还有3V3、1V1等模式，以及娱乐模式如克隆大作战等。
- 《英雄联盟》主要模式为5V5召唤师峡谷，还有3V3、大乱斗等模式，玩法多样。
#### 2.2.2 游戏节奏与时长
- 《王者荣耀》游戏节奏快，时长一般在15-20分钟，适合移动平台碎片化时间游玩。
- 《英雄联盟》游戏节奏相对较慢，时长一般在30-60分钟，注重团队协作和策略。
#### 2.2.3 游戏地图与资源
- 《王者荣耀》地图设计简洁，资源分布合理，野怪刷新快，适合快节奏游戏。
- 《英雄联盟》地图设计复杂，资源丰富，野怪刷新时间长，注重团队协作和资源控制。
### 2.3 游戏系统与机制
#### 2.3.1 等级与经验系统
- 《王者荣耀》等级系统简单，玩家通过升级获得英雄和皮肤奖励，等级提升可解锁更多功能。
- 《英雄联盟》等级系统复杂，玩家通过升级获得英雄和皮肤奖励，等级提升可解锁更多英雄。
#### 2.3.2 装备与道具系统
- 《王者荣耀》装备系统简单，玩家可快速购买和升级装备，装备属性提升明显。
- 《英雄联盟》装备系统复杂，玩家可购买多种装备，装备属性提升缓慢，需要玩家合理搭配。
#### 2.3.3 战斗与技能系统
- 《王者荣耀》战斗系统简单，技能释放简单易懂，适合移动平台操作。
- 《英雄联盟》战斗系统复杂，技能释放需要精准操作，竞技性更强。
## 3. 社区与文化对比
### 3.1 社区平台与功能
#### 3.1.1 社区平台功能
- 《王者荣耀》社区平台功能丰富，玩家可在社区交流游戏心得、分享攻略、参与活动等。
- 《英雄联盟》社区平台功能强大，玩家可在社区交流游戏心得、分享攻略、参与赛事等。
#### 3.1.2 社区活动与赛事
- 《王者荣耀》社区举办多种活动，如KPL赛事、玩家见面会等，活动形式多样，参与度高。
- 《英雄联盟》社区举办S系列赛等赛事，赛事规模大，奖金池高，吸引了全球众多玩家参与。
#### 3.1.3 社区氛围与文化
- 《王者荣耀》社区氛围活跃，玩家热情友好，社区文化积极向上，适合新手玩家。
- 《英雄联盟》社区氛围严肃，玩家竞技意识强，社区文化注重竞技精神，适合资深玩家。
### 3.2 粉丝文化与群体
#### 3.2.1 粉丝群体特点
- 《王者荣耀》粉丝群体庞大，涵盖各年龄段，粉丝文化积极向上，粉丝热情友好。
- 《英雄联盟》粉丝群体以年轻人为主，粉丝文化注重竞技精神，粉丝热情高涨。
#### 3.2.2 文化传播与影响
- 《王者荣耀》通过游戏、赛事、周边等方式传播文化，提升了玩家对传统文化的认知。
- 《英雄联盟》通过游戏、赛事、周边等方式传播文化，提升了玩家对西方文化的认知。
#### 3.2.3 社区建设与发展
- 《王者荣耀》社区不断发展，通过举办线上线下活动，增强玩家之间的互动和粘性。
- 《英雄联盟》社区注重玩家反馈，不断优化社区功能，提升玩家的体验和满意度。
## 4. 玩家体验与选择
### 4.1 游戏体验
#### 4.1.1 上手难度
- 《王者荣耀》操作简单，新手玩家可快速上手，适合碎片化时间游玩。
- 《英雄联盟》操作复杂，需要花费大量时间练习，竞技性更强。
#### 4.1.2 游戏节奏
- 《王者荣耀》游戏节奏快，适合快节奏的玩家。
- 《英雄联盟》游戏节奏相对较慢，注重团队协作和策略。
#### 4.1.3 游戏深度
- 《王者荣耀》游戏深度相对较浅，适合休闲玩家。
- 《英雄联盟》游戏深度较深，适合竞技玩家。
### 4.2 玩家选择
#### 4.2.1 玩家偏好
- 《王者荣耀》适合喜欢快节奏、操作简单的玩家。
- 《英雄联盟》适合喜欢深度策略、竞技性强的玩家。
#### 4.2.2 玩家群体
- 《王者荣耀》玩家群体广泛，涵盖各年龄段。
- 《英雄联盟》玩家群体以年轻人为主，竞技意识强。
#### 4.2.3 玩家留存
- 《王者荣耀》凭借便捷的操作和丰富的活动，拥有较高的玩家留存率。
- 《英雄联盟》凭借深度的玩法和成熟的电竞生态，吸引了大量忠实玩家。
`,
    `# 2025房贷利率新政全解
## 一、新政出台背景与目的
### 宏观经济形势影响
#### 经济增长态势分析
- 阐述2025年整体经济增长速度、产业结构调整情况，如传统制造业转型、新兴产业崛起对经济的影响，说明经济增长放缓或加速如何促使政府调整房贷利率政策以刺激或稳定房地产市场。
#### 通货膨胀与物价水平
- 分析2025年通货膨胀率、物价指数变化，如食品、能源等价格波动，解释通胀压力下房贷利率调整如何平衡居民购房负担与物价稳定。
### 房地产市场现状与问题
#### 市场供需关系
- 呈现2025年不同城市、区域的住房供应量（新房、二手房）与需求量数据，如一线城市库存周期、三四线城市去化情况，说明供需失衡如何推动新政出台。
#### 房价走势与风险
- 展示2025年房价指数变化，分析房价过快上涨或下跌带来的金融风险、社会稳定问题，阐述新政对抑制房价泡沫或稳定市场的意图。
### 政策目标设定
#### 促进房地产市场平稳健康发展
- 解释新政如何通过调整房贷利率，引导购房需求合理释放，避免市场大起大落，实现供求平衡。
#### 支持居民合理住房需求
- 说明新政对首次购房、改善性购房群体的优惠政策，降低购房门槛和成本，提高居民住房保障水平。

## 二、新政核心内容解读
### 利率调整机制
#### 基准利率变动情况
- 详细说明2025年央行公布的贷款基准利率调整幅度、方向，如上调或下调多少个百分点，以及调整的时间节点。
#### 利率浮动规则
- 解释银行在基准利率基础上浮动比例的规定，包括首套房、二套房利率浮动上限和下限，如首套房利率最低可下浮至基准利率的百分之多少。
### 差别化信贷政策
#### 首套房与二套房认定标准
- 明确2025年首套房、二套房的认定条件，如是否以家庭为单位、名下房产套数、贷款记录等，举例说明不同情况下的认定结果。
#### 不同类型房产的利率差异
- 阐述普通住宅、非普通住宅（如别墅、商业用房）的房贷利率区别，分析政策对不同房产类型的影响。
### 优惠与补贴政策
#### 特定群体优惠
- 介绍针对首次购房青年、人才引进群体、低收入家庭等特定群体的房贷利率优惠政策，如利率折扣、财政补贴等。
#### 地区性补贴政策
- 列举部分城市或区域为吸引人才、促进房地产市场发展出台的补贴政策，如购房契税减免、贷款贴息等。

## 三、新政对不同群体影响分析
### 购房者
#### 首次购房者
- 计算新政下首次购房者的月供变化，以一套总价200万、贷款140万、30年期限的住房为例，对比新政前后月供金额，说明节省的利息支出。
- 分析新政对首次购房者购房时机、购房预算的影响，鼓励或引导其合理入市。
#### 改善性购房者
- 探讨改善性购房者在二套房认定标准变化后的利率成本变化，举例说明换房成本是增加还是降低。
- 评估新政对改善性购房需求释放的作用，分析其对房地产市场结构调整的影响。
#### 投资性购房者
- 分析新政对投资性购房者收益率的影响，通过计算租金回报率与房贷利率的差值，说明投资房产的盈利空间变化。
- 预测新政下投资性购房需求的趋势，判断其对房价和市场供需关系的影响。
### 银行与金融机构
#### 信贷业务调整
- 说明银行在新政下房贷业务的规模、结构变化，如首套房、二套房贷款占比调整，分析对银行利润的影响。
- 探讨银行为应对新政在风险评估、贷款审批流程等方面的改进措施。
#### 资金配置与市场竞争
- 分析银行在新政下资金配置的调整方向，如增加或减少房贷业务资金投入，以及对其他信贷业务的影响。
- 评估新政对银行间房贷市场竞争格局的影响，判断是否会引发利率战或服务竞争升级。

## 四、新政实施过程中可能面临的问题与挑战
### 政策执行与监管难题
#### 地方政策差异与协调
- 指出不同地区在执行新政时可能出现的政策偏差，如利率浮动幅度不一致、补贴标准不同，分析协调地方政策的困难和解决方案。
#### 银行执行不到位问题
- 探讨银行在新政执行过程中可能出现的拖延、变相提高利率等违规行为，提出加强监管的措施和建议。
### 市场反应与预期管理
#### 购房者预期波动
- 分析新政出台后购房者对房价、利率走势的预期变化，可能导致的市场观望情绪或抢购现象，说明如何引导购房者形成合理预期。
#### 房地产市场短期波动
- 预测新政实施初期房地产市场可能出现的成交量、房价波动情况，评估对市场稳定的影响，提出应对短期波动的策略。

## 五、应对新政的建议与策略
### 购房者应对策略
#### 合理规划购房时间
- 根据新政实施节奏和市场走势，建议购房者在利率较低、政策优惠期合理选择购房时间，避免盲目跟风。
#### 优化购房预算与贷款方案
- 指导购房者根据自身经济状况和新政利率变化，调整购房预算，选择合适的贷款期限、还款方式，降低购房成本。
### 银行与金融机构应对措施
#### 加强风险管理
- 建议银行完善房贷业务风险评估体系，加强对借款人信用状况、还款能力的审核，防范信贷风险。
#### 创新金融产品与服务
- 鼓励银行开发适应新政的房贷金融产品，如固定利率贷款、混合利率贷款等，提供个性化金融服务，提高市场竞争力。
### 政府与监管部门政策完善方向
#### 加强政策宣传与解读
- 提出政府和监管部门应通过多种渠道加强对新政的宣传和解读，提高政策知晓度，引导市场主体正确理解政策意图。
#### 持续监测与动态调整
- 建议政府和监管部门建立房地产市场监测机制，及时掌握新政实施效果和市场变化情况，根据需要动态调整政策，确保政策目标的实现。
`
  ]
  useEffect(() => {
    const params = {
      id: record.show_id
    }
    newGetappList(params).then((res) => {
      console.log('res', res)
      if (res.code === 200) {
        setRecord(res.data)
        setApiToken(res.data.token)
        setAppId(res.data.project_app.app_id)
        // 同步更新name和desc以保持一致
        setDomain(res.data.domain)
        setNotice_url(res.data.notice_url)
        setName(res.data.name)
        setDesc(res.data.desc)
      }
    })
  }, [record.show_id])

  const onChangeInfo = useCallback(
    (newName, newDesc, newDomain, newNoticeUrl) => {
      let hasError = false

      // 检查标题长度
      if (newName && newName.length > 10) {
        Notification.warning({ content: '修改标题超过10个字！' })
        hasError = true
        // 恢复原始标题
        setName(record.name)
      }

      // 检查描述长度
      if (newDesc && newDesc.length > 32) {
        Notification.warning({ content: '修改内容超过32个字！' })
        hasError = true
        // 恢复原始描述
        setDesc(record.desc)
      }

      if (hasError) return

      // 构建请求参数，包含需要更新的字段
      let params = {
        id: record.show_id,
        name: newName,
        desc: newDesc,
        domain: newDomain,
        notice_url: newNoticeUrl
      }

      upDataInfo(params)
        .then((res) => {
          if (res.code === 200) {
            Notification.success({ content: '更新成功！' })
            // 更新本地record状态
            setRecord((prev) => ({
              ...prev,
              name: newName,
              desc: newDesc,
              domain: newDomain,
              notice_url: newNoticeUrl
            }))
          } else {
            Notification.error({ content: res.msg || '更新失败！' })
            // 更新失败时恢复原始值
            setName(record.name)
            setDesc(record.desc)
            setDomain(record.domain)
            setNotice_url(record.notice_url)
          }
        })
        .catch((error) => {
          Notification.error({ content: '网络错误，请稍后重试！' })
          // 错误时恢复原始值
          setName(record.name)
          setDesc(record.desc)
          setDomain(record.domain)
          setNotice_url(record.notice_url)
        })
    },
    [record.show_id, record.name, record.desc, record.domain, record.notice_url]
  )

  useEffect(() => {
    // 只有当name或desc有实际值且与record中的值不同时才考虑更新
    if (
      name !== undefined &&
      desc !== undefined &&
      (name !== record.name || desc !== record.desc)
    ) {
      // 设置防抖定时器，延迟500ms执行更新
      const timeoutId = setTimeout(() => {
        onChangeInfo(name, desc, domain, notice_url)
      }, 800) // 500ms的延迟时间，可以根据需要调整
      // 在组件重新渲染或卸载时清除定时器，避免重复执行
      return () => clearTimeout(timeoutId)
    }
  }, [
    name,
    desc,
    domain,
    notice_url,
    onChangeInfo,
    record.name,
    record.desc,
    record.domain,
    record.notice_url
  ])

  const debounce = (func, delay) => {
    let timer = null
    return function (...args) {
      if (timer) {
        clearTimeout(timer)
      }
      timer = setTimeout(() => {
        func.apply(this, args)
      }, delay)
    }
  }

  const handleGetEditorUrl = debounce(async (json) => {
    if (type === 'MD格式生成') {
      console.log('MD格式生成', record)
      getTextToEditorUrl(text)
    } else if (type === 'json格式生成') {
      console.log('json格式生成', json)
      getJsonToEditorUrl(json)
    }
  }, 800)

  const getJsonToEditorUrl = async (json) => {
    console.log(json, 'json')
    const params = {
      json_url: attachment,
      ref_url: '',
      app_id: record.project_app.app_id
    }
    const res = await jsonToEditorUrl(params)
    console.log(res, 'res')
    if (res.code === 200) {
      setPptUrl(res.data.saas_ppt)
    }
  }
  // 文本大纲生成编辑器
  const getTextToEditorUrl = async (text) => {
    console.log(text, 'text')
    const params = {
      text: text,
      ref_url: '',
      app_id: record.project_app.app_id
    }
    const res = await textToEditorUrl(params)
    console.log(res, 'res')
    if (res.code === 200) {
      setPptUrl(res.data.saas_ppt)
    }
  }

  const setFile = (fileLists, file) => {
    setFileList(fileLists)
    if (file.status === 'done') {
      let key = []
      let fileList = fileLists
      fileLists.forEach((item, index) => {
        key.push(item.response.fileKey)
      })
      setAttachment(key)
      setFileList(fileList)
    }
  }

  const handleUpload = (option) => {
    // upload(option)
    const client = new BosClient({})
    const file = option.file
    const param = {
      type: 'onlineEditorJson',
      mime: option.file.type || 'application/octet-stream',
      size: option.file.size,
      file: option.file.name
    }
    upload(param).then((res) => {
      if (res.code === 200) {
        // 配置百度云的配置
        //  console.log(res.data.buck_name,'777');

        setAttachment(res.data.result_url)
        const bosConfig = {
          endpoint: res.data.end_point, // 传入Bucket所在区域域名
          credentials: {
            ak: res.data.accessKeyID, // 您的AccessKey
            sk: res.data.secretAccessKey // 您的SecretAccessKey
          },
          sessionToken: res.data.sessionToken // STS服务器下发的sessionToken
        }
        client.config = bosConfig
        const bucket = res.data.buck_name
        console.log(bucket, res.data.object_key, bosConfig)

        // 定义成功和失败回调
        const done = (response) => {
          // 成功回调
          //  yoo.upload.loading("loading_success", "上传成功");
        }

        const fail = (fail) => {
          // 失败回调
          //  console.log(fail, 'err');
          //  yoo.common.notice(fail.message);
          //  yoo.upload.loading("loading_fail", "上传出错");
        }

        // 开始上传
        client
          .putObjectFromBlob(bucket, res.data.object_key, file)
          .then(done)
          .catch(fail)

        // 监听上传进度
        client.on('progress', function (evt) {
          if (evt.lengthComputable) {
            let percentageValue = parseInt((evt.loaded / evt.total) * 100 + '')
            //  console.log('上传中，已上传了' + percentageValue + '%');
          }
        })
      }
    })
  }

  const beforeUpload = (file) => {
    var AllImgExt = '.json|'
    var extName = file.name.substring(file.name.lastIndexOf('.')).toLowerCase() //（把路径中的所有字母全部转换为小写）
    if (AllImgExt.indexOf(extName + '|') === -1) {
      let ErrMsg =
        '该文件类型不允许上传。请上传 .json类型的文件，当前文件类型为' + extName
      Message.error(ErrMsg)
      return false
    }
    const isLt10M = !(
      b2ValueUnit(file.size)[1] === 'B' ||
      b2ValueUnit(file.size)[1] === 'KB' ||
      (b2ValueUnit(file.size)[1] === 'MB' && b2ValueUnit(file.size)[0] <= 5)
    )
    return new Promise((resolve, reject) => {
      if (isLt10M) {
        Message.error('上传文件不能大于5MB')
        reject()
      } else {
        resolve()
      }
    })
  }

  const handleTryExample = () => {
    const i = exampleTextList.indexOf(text)
    setText(exampleTextList[i === exampleTextList.length - 1 ? 0 : i + 1])
  }

  const handleClear = () => {
    setText('')
  }

  return (
    <>
      <div className="Header-init" id="Header_init"></div>
      <div className="edit-title">
        <div className="Header-init">
          <div className="Header-title">
            <Typography.Paragraph
              className="Header-uptitle"
              editable={{
                onChange: (value) => {
                  setName(value)
                }
              }}
            >
              {name}
            </Typography.Paragraph>
          </div>
        </div>
        <div className="Header-upParagraph">
          <Typography.Paragraph
            className="Header-uptitle"
            editable={{
              onChange: (value) => {
                setDesc(value)
              }
            }}
          >
            {desc}
          </Typography.Paragraph>
        </div>
      </div>
      <div className="GroupTable-fixe sass" id="hedSearch">
        <Tooltip
          content="JSON格式生成功能暂未开放"
          position="top"
          trigger="click"
        >
          <Radio.Group
            type="button"
            name="direction"
            value={type}
            onChange={(val) => {
              setType(val)
            }}
            options={options}
            className="GroupTable "
          ></Radio.Group>
        </Tooltip>

        <div>
          <Space size={'large'}>
            <Space align={'center'} size={'medium'}>
              <Button
                shape="round"
                className="primary-white custom-White-button"
                onClick={() => {
                  window.open(
                    `https://wiki.yoo-ai.com/api/AIGC/saas-expansion-api.html`
                  )
                }}
              >
                API文档
              </Button>
            </Space>
            {/* <Space align={'center'} size={'medium'}>
              <Button
                shape="round"
                className="primary-white custom-White-button"
                onClick={() => {
                  window.open(
                    `https://www.apifox.cn/apidoc/shared-11111111111111111111111111111111`
                  )
                }}
              >
                调用明细
              </Button>
            </Space> */}

            <Space align={'center'} size={'medium'}>
              <Trigger
                popupVisible={visible}
                position="br"
                popupAlign={{
                  bottom: 15
                }}
                popup={() => (
                  <div className="aigcSetting">
                    <div className="setting-item">
                      Token
                      <div className="primary_model_name primary_model_name_aigc primary_model_token_aigc">
                        <div className="primary_model_name_fix">
                          <span className="primary_model_name_title">
                            <Divider type="vertical" />
                          </span>
                          <Typography.Paragraph ellipsis copyable>
                            {apiToken}
                          </Typography.Paragraph>
                        </div>
                      </div>
                    </div>
                    <div className="setting-item">
                      APP_ID
                      <div className="primary_model_name primary_model_name_aigc primary_model_token_aigc">
                        <div className="primary_model_name_fix">
                          <span className="primary_model_name_title">
                            <Divider type="vertical" />
                          </span>
                          <Typography.Paragraph ellipsis copyable>
                            {appId}
                          </Typography.Paragraph>
                        </div>
                      </div>
                    </div>
                    {/* <div className="setting-item">
                      安全域名
                      <Tooltip
                        className="monthly-tooltip"
                        color="#FFFFFF"
                        position="right"
                        style={{ width: 200 }}
                        trigger="hover"
                        content="输入对接地址的安全域名，以保证对接的安全性"
                      >
                        <IconQuestionCircle
                          style={{
                            color: '#515C6B',
                            cursor: 'pointer',
                            marginLeft: '6px'
                          }}
                        />
                      </Tooltip>
                      <div className="sass-setting-info-input">
                        <Input
                          className="sass-setting-infoInput"
                          placeholder="请填写你的安全域名"
                          value={domain}
                          onChange={(e) => setDomain(e)}
                        />
                      </div>
                    </div>
                    <div className="setting-item">
                      通知地址
                      <Tooltip
                        className="monthly-tooltip"
                        color="#FFFFFF"
                        position="right"
                        style={{ width: 200 }}
                        trigger="hover"
                        content="可向该地址同步下载等事件的通知信息"
                      >
                        <IconQuestionCircle
                          style={{
                            color: '#515C6B',
                            cursor: 'pointer',
                            marginLeft: '6px'
                          }}
                        />
                      </Tooltip>
                      <div className="sass-setting-info-input">
                        <Input
                          className="sass-setting-infoInput"
                          placeholder="请填写回调通知信息的地址"
                          value={notice_url}
                          onChange={(e) => setNotice_url(e)}
                        />
                      </div>
                    </div> */}
                    <div style={{ textAlign: 'right' }}>
                      <Button
                        className="primary-white refesh_token_btn btn"
                        shape="round"
                        type="primary"
                        onClick={() => {
                          onChangeInfo(name, desc, domain, notice_url)
                          setVisible(false)
                        }}
                        style={{ padding: '0 30px', borderRadius: '8px' }}
                      >
                        保存
                      </Button>
                    </div>
                  </div>
                )}
                trigger="click"
                classNames="zoomInTop"
                onVisibleChange={(newVisible) => {
                  setVisible(newVisible)
                }}
              >
                <div className="setting_primary_model_name">
                  {/* <IconSettings />  */}
                  配置信息
                </div>
              </Trigger>
            </Space>
          </Space>
        </div>
      </div>
      <div className="saasPPT-content">
        <div className="left">
          {type === 'MD格式生成' ? (
            <div className="markdown-box">
              <textarea
                onChange={(e) => {
                  setText(e.target.value)
                }}
                value={text}
                className="input"
                type="text"
                placeholder={`请输入MarkDown大纲文本（200字以上）
示例格式（可直接按照该示例格式提交给大模型）：
# 标题
## 一级大纲1
### 二级大纲
#### 正文小标题
- 正文内容
#### 正文小标题
- 正文内容
......
### 二级大纲
#### 正文小标题
- 正文内容
......
## 一级大纲2
......`}
              />
              <div className="btn-group">
                <div className="btn-c" onClick={handleTryExample}>
                  <div className="icon icon-circle" />
                  试试示例
                </div>
                <div className="btn-c" onClick={handleClear}>
                  <div className="icon icon-clear" />
                  清空
                </div>
              </div>
            </div>
          ) : (
            <div className="upload-box">
              <div className="uploadTip">导入json文件</div>
              <Upload
                accept=".json"
                fileList={fileList}
                // renderUploadList={this.renderUploadList}
                limit={1}
                onChange={setFile}
                customRequest={(option) => {
                  handleUpload(option)
                }}
                className="upload"
                beforeUpload={beforeUpload}
                onExceedLimit={() => {
                  Message.warning('超过上传数量限制！最多上传1个')
                }}
              >
                <div className="rowCenter trigger">
                  <span className="iconfont icon-icon_chuangjian_24"></span>
                  <div>点击此处上传文件</div>
                </div>
              </Upload>
            </div>
          )}
          <Button
            className="primary-white refesh_token_btn btn"
            shape="round"
            type="primary"
            onClick={() => {
              handleGetEditorUrl(text)
            }}
          >
            生成ppt
          </Button>
        </div>

        <div className="right">
          {!pptUrl ? (
            <div className="empty">
              <div className="empty-img">
                <img src={Emptydata_img} alt="" />
              </div>
              <div className="empty-desc">在左侧导入大纲内容，预览渲染效果</div>
            </div>
          ) : (
            <iframe
              src={pptUrl}
              frameborder="0"
              title={type}
              className={`semanticprototype-Layout sass-semanticprototype-Layout`}
              style={{ width: '100%', height: '100%' }}
              allow="microphone; camera; geolocation; fullscreen; clipboard-write; compute-pressure;clipboard-read;"
              allowfullscreen
            ></iframe>
          )}
        </div>
      </div>
    </>
  )
}

export default SaasPPT
